angular.module('clientDashboardApp').directive('abbreviateLastName',() => {
  return {
    restrict: 'A',
    template: `<span>{processedName}</span>`,
    scope: {
      name:'='
    },
    controller: ($scope) => {
      let names = $scope.name.split(' ')
      let lastInitial = names.length > 1 ? names[names.length - 1].split()[0]+"." : ""
      $scope.processedName = names.slice(0,names.length - 2).join(" ") + lastInitial
    }
  }
})
